import * as React from 'react';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { ThemeContext } from 'styled-components';

import Text, { ITextProps } from './Text';

interface IPillTextProps extends ITextProps {
  variant: string;
}

const PillText: React.FC<IPillTextProps> = ({ children, variant, ...restProps }) => {
  const { themeTwo: { typography: { pill }}} = React.useContext(ThemeContext);
  const pillVariantTheme = pill[variant];
  const theme = merge({}, pill.default, pillVariantTheme);
  const restTheme = omit(theme, 'font');

  return <Text {...theme.font} {...restTheme} {...restProps}>{children}</Text>;
};

export default PillText;
